export default __webpack_public_path__ + "static/media/monitor.47018169.png";